<script setup lang="ts">
import { useRefreshReleaseNoteStore } from '@/releaseNotes/stores/refreshReleaseNoteStore';
import { storeToRefs } from 'pinia';
import { Button, Skeleton } from 'primevue';
import ReleaseNoteView from 'shared/releaseNotes/components/ReleaseNoteView.vue'
import { useReleaseNoteStore } from 'shared/releaseNotes/stores/releaseNoteStore';
import { useTranslations } from 'shared/translations/composables/useTranslations';
import { computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';

const refreshReleaseNoteStore = useRefreshReleaseNoteStore();
const releaseNoteStore = useReleaseNoteStore();
const { latest: note } = storeToRefs(releaseNoteStore)
const translations = useTranslations();

const loading = computed(
  () => refreshReleaseNoteStore.loading,
);

onMounted(() => {
  void Promise.all([
    refreshReleaseNoteStore.initialize()
  ]);
});

const router = useRouter();

function onShowMoreClick() {
  router.push("releaseNotes");
}

</script>

<template>
  <div class="release-note">
    <Skeleton v-if="loading" height="100%" />
    <div v-else>
      <ReleaseNoteView v-if="note" v-model:model-value="note"></ReleaseNoteView>
      <Button variant="text" :label="translations.generic.showMore" @click="onShowMoreClick"></Button>
    </div>
  </div>
</template>

<style scoped>
.release-note {
  overflow-y: auto;
  max-height: 100%;
}
</style>
